import React from "react";

export interface IconProps extends React.SVGAttributes<HTMLOrSVGElement> {
  size?: number;
}

export const IconHome: React.FC<IconProps> = ({ size = 24, ...rest }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <g clipPath="url(#clip0_88_15868)">
          <path
            d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z"
            fill="#616161"
          />
        </g>
        <defs>
          <clipPath id="clip0_88_15868">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
